export default __webpack_public_path__ + "static/media/bw_light.3b46dd6f.png";